import Bloc from './Bloc.js';
import Types from './Types.js';

export default class TurnBack extends Bloc {

	constructor (src, ctx) {

		super("turnback", src, ctx, true);
		this.f = (src, ins, props) => {
			let player = src.master.player;
			if (player.hasStatus("facing-back") || player.hasStatus("exposed"))
				return;
			player.apply("facing-back", player.champion.level);
			src.master.notify("turnback", player);
			return;
		};
		this.types = [];
	}
}